import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import s from "./WaterPanel.module.css";
export default function WaterPanel({ glasses, target, onSet }) {
    function handleClick(i) {
        if (i < glasses) {
            onSet(Math.max(0, glasses - 1));
        }
        else {
            onSet(i + 1);
        }
    }
    return (_jsxs("div", { className: s.panel, children: [_jsxs("div", { className: s.wCount, children: [glasses, _jsxs("span", { className: s.wCountSub, children: ["/ ", target, " glasses"] })] }), _jsx("div", { className: s.wGrid, children: Array.from({ length: target }, (_, i) => (_jsx("div", { className: `${s.wg}${i < glasses ? ` ${s.wgFilled}` : ""}`, onClick: () => handleClick(i), children: _jsx("svg", { viewBox: "0 0 24 24", children: _jsx("path", { d: "M5 3h14l-2 13a2 2 0 01-2 2H9a2 2 0 01-2-2L5 3z" }) }) }, i))) })] }));
}
//# sourceMappingURL=WaterPanel.js.map